import {combineReducers} from 'redux';
import fuse from './fuse';
import auth from '../actionreducers/auth/index';
import contactsApp from '../actionreducers/trial_vip/index';
import ReduxTrialVip from '../actionreducers/trialVip';
import ReduxVip from '../actionreducers/vip';
import ReduxUser from '../actionreducers/user';
import ReduxGroup from '../actionreducers/group';
import ReduxCompany from '../actionreducers/company';
import ReduxGlobal from '../actionreducers/globalView';
import ReduxMissionPriceType from '../actionreducers/missionPriceType';
import ReduxMission from '../actionreducers/mission';
import ReduxFeedback from '../actionreducers/feedback';
import ReduxSurveyCount from '../actionreducers/surveyCount'
import ReduxCalender from '../actionreducers/calender';
import ReduxNewCalender from '../actionreducers/new-calendar';
import ReduxGroupType from '../actionreducers/groupType';
import ReduxUseRecord from '../actionreducers/useRecord';
import ReduxCity from '../actionreducers/city';
import ReduxPricePlan from '../actionreducers/pricePlan';
import ReduxInstitution from '../actionreducers/institution';
import ReduxCallHelper from '../actionreducers/callHelper';
import ReduxAdminMedicalList from '../actionreducers/adminMedical/medical'
import applyMedicalsApp from '../actionreducers/apply_medical/index';
import analyticsDashboardApp from '../../main/content/analytics/store/reducers/index';

const rootReducer = combineReducers({
    auth,
    fuse,
    contactsApp,
    trialVip: ReduxTrialVip.Reducer,
    vip: ReduxVip.Reducer,
    user: ReduxUser.Reducer,
    group: ReduxGroup.Reducer,
    pricePlan: ReduxPricePlan.Reducer,
    city: ReduxCity.Reducer,
    company: ReduxCompany.Reducer,
    missionPriceType: ReduxMissionPriceType.Reducer,
    mission: ReduxMission.Reducer,
    feedback: ReduxFeedback.Reducer,
    surveyCount: ReduxSurveyCount.Reducer,
    groupType: ReduxGroupType.Reducer,
    callHelper: ReduxCallHelper.Reducer,
    adminMedicalList: ReduxAdminMedicalList.Reducer,
    institution: ReduxInstitution.Reducer,
    useRecord: ReduxUseRecord.Reducer,
    calendarApp: ReduxCalender.Reducer,
    newCalendarApp: ReduxNewCalender.Reducer,
    global: ReduxGlobal.Reducer,
    applyMedicalsApp,
    analyticsDashboardApp,
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/store/reducers/index.js